import { Search, Plus, Archive } from "lucide-react";
import CustomSelect from "../../../components/ui/CustomSelect";
import { Button } from "../../../components/ui/button";

const CLASSES_ACTIFS = [
  { label: "Toutes les classes", value: "Toutes les classes" },
  { label: "Fonds Commun de Placement", value: "Fonds Commun de Placement" },
  { label: "Fonds d'Investissement Alternatif", value: "Fonds d'Investissement Alternatif" },
  { label: "Cryptomonnaies", value: "Cryptomonnaies" },
  { label: "Produits Structurés", value: "Produits Structurés" },
  { label: "Private Equity", value: "Private Equity" },
  { label: "Produits Immobiliers", value: "Produits Immobiliers" },
  { label: "Gestion Sous Mandat", value: "Gestion Sous Mandat" },
  { label: "BUFFER ETF", value: "BUFFER ETF" },
  { label: "Dette Privée", value: "Dette Privée" },
  { label: "Investissements Alternatifs", value: "Investissements Alternatifs" },
  { label: "Services Exclusifs", value: "Services Exclusifs" },
  { label: "Assurance-Vie LUX", value: "Assurance-Vie LUX" },
];

export default function SearchBar({
  query, onQueryChange, selectedClasse, onClasseChange, onAdd, onArchives, isArchivesView,
}) {
  return (
    <div className="w-full min-w-0">
      <div className="flex flex-col sm:flex-row sm:flex-wrap items-center gap-3 w-full">
        <div className="w-full sm:w-64 relative flex-shrink-0">
          <div className="flex items-center bg-white/10 backdrop-blur-md border border-white/20 rounded-md px-3 py-2 shadow-hp-sm focus-within:ring-2 focus-within:ring-[var(--hp-primary-400)] transition-all">
            <Search className="h-4 w-4 text-white/70 mr-2 shrink-0" aria-hidden="true" />
            <input
              type="search"
              className="w-full bg-transparent focus:outline-none text-sm text-white placeholder-white/50"
              placeholder="Rechercher dans cette page…"
              aria-label="Rechercher des partenaires dans cette page"
              value={query}
              onChange={(event) => onQueryChange(event.target.value)}
            />
          </div>
        </div>

        <div className="w-full sm:w-56 shrink-0">
          <CustomSelect
            value={selectedClasse}
            onChange={onClasseChange}
            options={CLASSES_ACTIFS}
            triggerClassName="!bg-white/10 !backdrop-blur-md !border-white/20 !text-white hover:!bg-white/20 shadow-hp-sm"
          />
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:ml-auto">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className={`shadow-hp-sm ${isArchivesView ? "bg-white/20 text-white" : "bg-white/10 text-white/80 hover:bg-white/20"} backdrop-blur-md border border-white/20`}
            onClick={onArchives}
            aria-label={isArchivesView ? "Quitter les archives" : "Voir les archives"}
            title={isArchivesView ? "Quitter les archives" : "Voir les archives"}
          >
            <Archive className="h-4 w-4 mr-1.5" aria-hidden="true" />
            <span className="hidden sm:inline">Archives</span>
          </Button>
          <Button
            type="button"
            variant="accent"
            size="sm"
            className="shadow-hp-sm whitespace-nowrap border-transparent"
            onClick={onAdd}
          >
            <Plus className="h-4 w-4 mr-1.5" aria-hidden="true" />
            Ajouter
          </Button>
        </div>
      </div>
      <p className="mt-2 text-xs text-inverse opacity-80">
        Recherche et classe d’actifs : dans cette page uniquement.
      </p>
    </div>
  );
}
